/* Common Imports */

import { styled } from "@mui/system";
import React from "react";

/* Redux & Type Imports */

import { NextRouter } from "next/router";
import StateInterface from "../../../../redux-magic/state-interface";
import { Participants } from "../../../../redux-magic/sub-interfaces/chat-interface";
import { CurrentChatInterface } from "../../../../redux-magic/sub-interfaces/chat-states-interface";

/* Component Imports */

import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";
import MessageSection from "./MessageSection";

/* Styled Components */

const RootDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	height: "100%",
	background: theme.palette.background.paper,
}));

interface FileAndMore {
	file: File;
	mime_type: string;
}

const SingleChatScreen = ({
	session,
	dispatch,
	router,
	profile_context,
	current_chat_data,
	desktop_fullscreen_mode,
}: {
	session: StateInterface["redux_session"];
	dispatch: Function;
	router: NextRouter;
	profile_context: any;
	current_chat_data: CurrentChatInterface;
	desktop_fullscreen_mode: boolean;
}) => {
	/* Private Chat Receiver */

	const private_chat_receiver: Participants = [...current_chat_data.participants].splice(
		current_chat_data.participants.findIndex((participant: any) =>
			profile_context.is_business_profile
				? participant.business_profile_id?._id !== profile_context.business_profile_id
				: participant.user_id?._id !== (session ? (session.user ? session.user.dbUser._id : "") : ""),
		),
		1,
	)[0];

	const [selectedFilePreview, setSelectedFilePreview] = React.useState<Array<string>>([]);

	const [pendingUploads, setPendingUploads] = React.useState<Array<FileAndMore>>([]);

	const [current_message, setCurrentMessage] = React.useState<string>("");

	const [sendFiles, setSendFiles] = React.useState<boolean>(false);

	return (
		<RootDiv>
			{/* Chat Header */}

			<ChatHeader
				session={session}
				dispatch={dispatch}
				router={router}
				profile_context={profile_context}
				chat_id={current_chat_data.chat_id}
				chat_type={current_chat_data.chat_type}
				chat_title={current_chat_data.chat_title}
				chat_description={current_chat_data.chat_description}
				chat_is_broadcast={current_chat_data.is_broadcast}
				private_chat_receiver={private_chat_receiver}
				desktop_fullscreen_mode={desktop_fullscreen_mode}
			/>

			{/* Messages Section */}

			<MessageSection
				session={session}
				dispatch={dispatch}
				router={router}
				profile_context={profile_context}
				chat_id={current_chat_data.chat_id}
				messages={current_chat_data.messages}
				messages_count={current_chat_data.messages_count}
				messages_loading={current_chat_data.messages_loading}
				initial_load_done={current_chat_data.initial_load_done}
				filter_page_number={current_chat_data.filter_page_number}
				selected_files={selectedFilePreview}
				pending_uploads={pendingUploads}
				current_message={current_message}
				setCurrentMessage={setCurrentMessage}
				sendFiles={sendFiles}
				setSendFiles={setSendFiles}
				setSelectedFilePreview={setSelectedFilePreview}
				setPendingUploads={setPendingUploads}
			/>

			{/* Input Container  */}

			<ChatInput
				session={session}
				dispatch={dispatch}
				router={router}
				profile_context={profile_context}
				initial_load_done={current_chat_data.initial_load_done}
				messages_loading={current_chat_data.messages_loading}
				chat_id={current_chat_data.chat_id}
				selectedFilePreview={selectedFilePreview}
				setSelectedFilePreview={setSelectedFilePreview}
				pendingUploads={pendingUploads}
				setPendingUploads={setPendingUploads}
				current_message={current_message}
				setCurrentMessage={setCurrentMessage}
				setSendFiles={setSendFiles}
				sendFiles={sendFiles}
				messages_count={current_chat_data.messages_count}
			/>
		</RootDiv>
	);
};

export default SingleChatScreen;
